import crmApi from "./http-client";

export const getManufactureList = (token, zipcode) => {
	const url = `/settings/state-manufacturer`;
	const params = {};
	if (zipcode) params.zipcode = zipcode;
	return crmApi.get(url, {
		params
	});
};
export const getManufactureMetaData = (token) => {
	const url = "/settings/state-manufacturer/meta";
	return crmApi.get(url);
};
export const getManufactureDataById = (token, id) => {
	const url = `/settings/state-manufacturer/manufacturer/${id}`;
	return crmApi.get(url);
};
export const getManufacturePricingSheet = (token, id) => {
	const url = `/settings/manufacturers/${id}/pricing-sheet`;
	return crmApi.get(url);
};
export const getManufactureCount = (id) => {
	const url = `quotes/count-by-manufacturer/${id}`;
	return crmApi.get(url);
};
export const getDiscount = () => {
	const url = `/settings/manufacturers/discounts`;
	return crmApi.post(url);
};
export const taxFromZip = (payload) => {
	const url = `/quotes/tax-from-zip`;
	return crmApi.post(url, payload);
};
